export enum PathologyItem {
	DECAY = 'DECAY',
	ROOT_DECAY = 'ROOT_DECAY',
	FRACTURE = 'FRACTURE',
	TOOTH_WEAR = 'TOOTH_WEAR',
	DISCOLORATION = 'DISCOLORATION',
	APICAL = 'APICAL',
	DEVELOPMENT_DISORDER = 'DEVELOPMENT_DISORDER',
	EROSION = 'EROSION',
	ATTRITION = 'ATTRITION',
	ABFRACTION = 'ABFRACTION',
}
